import _ from "lodash";
import { v4 as uuidv4 } from "uuid";

const listTasks = async (callback) => {
  const saved = localStorage.getItem("todo-tasks");
  const initial = JSON.parse(saved);
  let tasks = initial || [];
  callback(tasks);
};

const insertTask = async (text) => {
  const saved = localStorage.getItem("todo-tasks");
  const initial = JSON.parse(saved);
  let tasks = initial || [];
  tasks.push({ _id: uuidv4(), isCompleted: false, text: text });
  await localStorage.setItem("todo-tasks", JSON.stringify(tasks));
};

const updateTask = async (id, isCompleted) => {
  const saved = localStorage.getItem("todo-tasks");
  const initial = JSON.parse(saved);
  let tasks = initial || [];
  const index = _.findIndex(tasks, (task) => task._id === id);
  if (index >= 0) {
    tasks[index].isCompleted = isCompleted;
  }
  await localStorage.setItem("todo-tasks", JSON.stringify(tasks));
};

const removeTask = async (id) => {
  const saved = localStorage.getItem("todo-tasks");
  const initial = JSON.parse(saved);
  let tasks = initial || [];
  tasks = tasks.filter((task) => task._id !== id);
  await localStorage.setItem("todo-tasks", JSON.stringify(tasks));
};

export { listTasks, insertTask, updateTask, removeTask };
